import { gql } from '@apollo/client'
import React from 'react'

import { fieldsClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useFieldsState = () => React.useContext(Context)
export const useFields = () => useFieldsState()?.fields

const QUERY = gql`
  query Fields($origin: [String]) {
    fields(filter: { origins: $origin }, limit: 999999999, sort: { field: ORDINATION, type: ASC }) {
      id
      name
      origin
      ordination
      required
      type
      defaultValue
      reference
      parentReference
      displayConditions
      configuration
      masks {
        id
        name
        pattern
      }
      options {
        id
        name
        reference
        ordination
      }
    }
  }
`

const FieldsLoader = ({ children }) => {
  const origin = useModalData()
  const { data, ...state } = useQuery(QUERY, {
    variables: { origin },
    client: fieldsClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state} empty={false}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default FieldsLoader
